import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { Provider } from 'mobx-react';
import './App.css';

// stores
import authStore from './store/authStore';
import userStore from './store/userStore';
import commonStore from './store/commonStore';
import dataStore from './store/dataStore';

import Routes from './components/Routes';

const stores = {
  authStore,
  userStore,
  commonStore,
  dataStore,
};

const App = () => (
  <Provider {...stores}>
    <Router>
      <Routes />
    </Router>
  </Provider>
);

export default App;



// WEBPACK FOOTER //
// ./src/App.js